<div class="wrap wrapMain coverPathWidget">
  <form class="coverPathForm" id="beneForm" [formGroup]="beneForm">
    <div class="formRow">
      <label for="name" class="headerLabel">Full Name</label>
      <fieldset class="name">
        <div class="contentPadding">
          <div class="split-row-col3">
            <div class="first">
              <basic-text-input
                [propertyName]="'firstName'"
                [placeholder]="'First name'"
                [parserType]="'Text'"
                [inputType]="'text'"
                type="text"
                formControlName="firstName"
                [formGroupComponent]="true"
              ></basic-text-input>
            </div>
            <div class="middle">
              <basic-text-input
                [propertyName]="'middleName'"
                [placeholder]="'Middle Name'"
                [parserType]="'Text'"
                [inputType]="'text'"
                type="text"
                formControlName="middleName"
                [formGroupComponent]="true"
              ></basic-text-input>
            </div>
            <div class="last">
              <basic-text-input
                [propertyName]="'lastName'"
                [placeholder]="'Last name'"
                [parserType]="'Text'"
                [inputType]="'text'"
                type="text"
                formControlName="lastName"
                [formGroupComponent]="true"
              ></basic-text-input>
            </div>
          </div>
        </div>
      </fieldset>
    </div>

    <div class="formRow">
      <div class="formElem">
        <label for="birthday" class="headerLabel">Date of Birth</label>
        <div class="contentPadding">
          <basic-text-input
            [propertyName]="'birthday'"
            [placeholder]="'MM/DD/YYYY'"
            [inputMask]="{mask: mask}"
            [parserType]="'Text'"
            [inputType]="'text'"
            type="text"
            formControlName="birthday"
            [formGroupComponent]="true"
          ></basic-text-input>
          <control-messages [control]="beneForm.controls.birthday"></control-messages>
        </div>
      </div>
    </div>

    <div class="formRow">
      <fieldset class="address">
        <div class="groupHeader">
          <label for="headerLabel" class="headerLabel">
            Address
            <span class="optional">(optional)</span>
          </label>
          <button type="button" class="btn-margin" (click)="resetAddress()">clear address</button>
        </div>
        <div class="split-row-col2 contentPadding">
          <div class="colLeft street contentPadding">
            <basic-text-input
              [propertyName]="'street'"
              [placeholder]="'Address line 1'"
              [parserType]="'Text'"
              [inputType]="'text'"
              type="text"
              formControlName="street"
              [formGroupComponent]="true"
            ></basic-text-input>
            <control-messages [control]="beneForm.controls.street"></control-messages>
          </div>
          <div class="colRight line1 contentPadding">
            <basic-text-input
              [propertyName]="'line1'"
              [placeholder]="'Address line 2'"
              [parserType]="'Text'"
              [inputType]="'text'"
              type="text"
              formControlName="line1"
              [formGroupComponent]="true"
            ></basic-text-input>
          </div>
        </div>
        <div class="split-row-col2 contentPadding">
          <div class="colLeft line2 contentPadding">
            <basic-text-input
              [propertyName]="'line2'"
              [placeholder]="'Address line 3'"
              [parserType]="'Text'"
              [inputType]="'text'"
              type="text"
              formControlName="line2"
              [formGroupComponent]="true"
            ></basic-text-input>
          </div>
          <div class="colRight city contentPadding">
            <basic-text-input
              [propertyName]="'city'"
              [placeholder]="'City'"
              [parserType]="'Text'"
              [inputType]="'text'"
              type="text"
              formControlName="city"
              [formGroupComponent]="true"
            ></basic-text-input>
            <control-messages [control]="beneForm.controls.city"></control-messages>
          </div>
        </div>
        <div class="split-row-col2 contentPadding">
          <div class="colLeft state contentPadding">
            <select-basic
              [propertyName]="'state'"
              [placeholder]="'State'"
              [optionValues]="stateList"
              formControlName="state"
              [label]="'State'"
              [formGroupComponent]="true"
            ></select-basic>
          </div>
          <div class="colRight zip contentPadding">
            <basic-text-input
              [propertyName]="'zip'"
              [placeholder]="'ZIP'"
              (valueChanged)="zipCodeLookup()"
              [parserType]="'Text'"
              [inputType]="'text'"
              type="text"
              formControlName="zip"
              [formGroupComponent]="true"
            ></basic-text-input>
            <control-messages [control]="beneForm.controls.zip"></control-messages>
          </div>
        </div>
      </fieldset>
    </div>

    <div class="formRow">
      <div class="split-row-col2">
        <div class="colLeft">
          <label for="phone" class="headerLabel">
            Phone Number
            <span class="optional">(optional)</span>
          </label>
          <div class="contentPadding">
            <basic-text-input
              [propertyName]="'phone'"
              [placeholder]="'10 digit phone'"
              (valueChanged)="formatPhone()"
              [parserType]="'Text'"
              [inputType]="'text'"
              type="text"
              formControlName="phone"
              [formGroupComponent]="true"
            ></basic-text-input>
            <control-messages [control]="beneForm.controls.phone"></control-messages>
          </div>
        </div>
        <div class="colRight">
          <label class="headerLabel" for="ssn">
            Social Security Number
            <span class="optional">(optional)</span>
          </label>
          <div class="contentPadding">
            <basic-text-input
              [propertyName]="'ssn'"
              [placeholder]="'9 digit SSN'"
              (valueChanged)="formatSSN()"
              [parserType]="'Text'"
              [inputType]="'text'"
              type="text"
              formControlName="ssn"
              [formGroupComponent]="true"
            ></basic-text-input>
            <control-messages [control]="beneForm.controls.ssn"></control-messages>
          </div>
        </div>
      </div>
    </div>
    <div class="formRow">
      <div class="split-row-col2">
        <div class="colLeft">
          <label for="email" class="headerLabel">
            Email
            <span class="optional">(optional)</span>
          </label>
          <div class="contentPadding">
            <basic-text-input
              [propertyName]="'email'"
              [placeholder]="'Email Address'"
              [parserType]="'Text'"
              [inputType]="'text'"
              type="text"
              formControlName="email"
              [formGroupComponent]="true"
            ></basic-text-input>
            <control-messages [control]="beneForm.controls.email"></control-messages>
          </div>
        </div>
      </div>
    </div>

    <div class="formRow" *ngIf="!spouse">
      <div class="formElem">
        <label class="headerLabel" for="otherRelationship">
          Relationship
          <span class="optional">(optional)</span>
        </label>
        <div class="contentPadding">
          <basic-text-input
            [propertyName]="'relationshipDescription'"
            [parserType]="'Text'"
            [inputType]="'text'"
            type="text"
            formControlName="relationshipDescription"
            [formGroupComponent]="true"
          ></basic-text-input>
        </div>
      </div>
    </div>

    <div class="formRow">
      <fieldset class="perstirpes">
        <label for="perstirpes" class="headerLabel">Per stirpes?</label>
        <div class="info">
          In the case of the beneficiary's death, would you like to distribute benefits equally amongst their
          descendants?
        </div>
        <radio-group
          [propertyName]="'perStirpe'"
          [valueOptions]="perStirpeOptions"
          formControlName="perStirpe"
          [formGroupComponent]="true"
        ></radio-group>
      </fieldset>
    </div>
  </form>
</div>

<div class="wrap wrapFoot">
  <div class="cta">
    <button type="submit" class="btnSubmit" [disabled]="isDisabled()" (click)="saveBene();">Submit</button>
    <button type="button" class="btnCancel" (click)="cancel();">Cancel</button>
  </div>
</div>
